import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AccessManager } from '@services/managers/access.manager';

/**
 * Check whether the current User is part of tbmaestro.
 * @return True if the route can be activated, or an UrlTree to /404 otherwise.
 */
export default function isTbGuard(): boolean | UrlTree {
  return inject(AccessManager).currentUser.isTb || inject(Router).parseUrl('404');
}
